<!-- Mobile Overlay Backdrop -->
@if (isMobile && isOpen) {
<div class="mobile-overlay" (click)="onOverlayClick()"></div>
}

<nav
  [class.sidebar-closed]="!isOpen"
  [class.mobile-sidebar]="isMobile"
  [class.mobile-sidebar-open]="isMobile && isOpen"
  class="sidebar"
>
  <div class="brand">
    <p-image
      class="w-24 h-auto cursor-pointer"
      src="assets/images/niti-logo.png"
      alt="NITI"
      (click)="onLogoClick()"
    ></p-image>
  </div>

  <ul class="nav-list">
    <li class="nav-item">
      @for (item of navItems; track item) {
      <a
        [routerLink]="item.route"
        routerLinkActive="active"
        class="nav-link"
        (click)="onNavItemClick()"
      >
        <i [class]="item.icon"></i>
        <span class="nav-text">{{ item.label }}</span>
      </a>
      }
    </li>
  </ul>
</nav>
